module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Operation name:","namePlaceholder":"Please enter Operation name","filter":"Filter","resetFilter":"Reset"},"hr":{"name":"Naziv operacije:","namePlaceholder":"Unesite naziv operacije","filter":"Pretraži","resetFilter":"Poništi"}}')
  delete Component.options._Ctor
}
